import AbstractModal from './AbstractModal';

export default class extends AbstractModal {
    constructor(m) {
        super(m);

        this.$content = this.$('content')[0]
        this.$imageTemplate = this.$('image-template')[0]

        this.$title = this.$('title')[0]
        this.$content = this.$('content')[0]
    }

    init() {
        super.init();
    }

    onOpen(args) {
        // Title
        if(args.title) {
            this.$title.innerText = args.title;
        }
        
        // Image
        if(args.image) {
            const clone = this.$imageTemplate.content.cloneNode(true);
            const image = clone.children[0]
            image.setAttribute('data-info-modal', 'image')
            const img = image.querySelector('img')
            img.src = args.image;
            this.$imageTemplate.after(clone)
        }        

        // Content
        if(args.content) {
            this.$content.innerHTML = args.content;
        }
    }

    onClose() {
        const $oldImage = this.$('image')[0];
        $oldImage?.remove?.();
    }
}
